module.exports = __webpack_public_path__ + "1b50fed4f6d9903a73b78e7f01f43d51.svg";